import { inject } from '@angular/core';
import { Router, CanActivateFn, GuardResult } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserRole } from '../api';

// TODO: Change the routes to the landingpage later
export function roleGuard(requiredRoles: UserRole | UserRole[]): CanActivateFn {
  return (): GuardResult => {
    const router = inject(Router);
    const authService = inject(AuthService);

    if (!authService.isUserAuthenticated) {
      return router.createUrlTree(['/auth/login']);
    }

    // Convert single role to array for consistent handling
    const roles = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];

    // If no required roles specified, allow access
    if (!roles || roles.length === 0) {
      return true;
    }

    // Check if user has any of the required roles
    const hasRequiredRole = roles.some((role) => authService.userIsInRole(role));

    if (hasRequiredRole) {
      return true;
    }

    // User doesn't have required role - redirect to unauthorized page
    return router.createUrlTree(['/main/dashboard']);
  };
}
